import React from 'react'
import { leaderBoardSkeletonStyle as styles} from "./leaderBoardSkeletonStyle.tailwind" 

const LeaderBoardSkeleton = ({ count = 3 }) => {
    return (
      <div className={styles.leaderboard_wrapper}>
        {Array.from({length: count})?.map((ele, key) => (
          <div className={styles.dataRow} key={key} />
        ))}
      </div>
    );
}

export default LeaderBoardSkeleton